import { component } from "picoapp";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration, { type Duration } from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const DEFAULT_TIMEZONE = "America/Los_Angeles";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

export const dateCountdown = component((node: HTMLElement) => {
  const endDateData = node.dataset.endDate;
  const endDate = dayjs.tz(endDateData);
  const currentUTCDate = dayjs.tz();

  let timeDifference = endDate.diff(currentUTCDate);

  const initialDuration = dayjs.duration(timeDifference);
  const daysEl = node.querySelector<HTMLElement>("[data-days]");
  const hoursEl = node.querySelector<HTMLElement>("[data-hours]");
  const minutesEl = node.querySelector<HTMLElement>("[data-minutes]");
  const secondsEl = node.querySelector<HTMLElement>("[data-seconds]");

  if (!initialDuration.days()) daysEl.style.display = "none";
  if (!initialDuration.hours()) hoursEl.style.display = "none";
  if (!initialDuration.minutes()) minutesEl.style.display = "none";
  if (!initialDuration.seconds()) secondsEl.style.display = "none";

  const updateCounters = (duration: Duration) => {
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const ms = duration.asMilliseconds();

    const daysText = `${days}d`;
    const hoursText = `${hours}h`;
    const minutesText = `${minutes}m`;
    const secondsText = `${seconds}s`;
    if (ms && ms > 0 && daysEl.textContent !== daysText) {
      daysEl.innerHTML = daysText;
    }

    if (ms && ms > 0 && hoursEl.textContent !== hoursText) {
      hoursEl.innerHTML = hoursText;
    }

    if (ms && ms > 0 && minutesEl.textContent !== minutesText) {
      minutesEl.innerHTML = minutesText;
    }

    if (ms && ms > 0 && secondsEl.textContent !== secondsText) {
      secondsEl.innerHTML = secondsText;
    }
  };

  const ms = initialDuration.asMilliseconds();
  if (!ms || ms <= 0) {
    node.innerHTML = "";
    return;
  }

  updateCounters(initialDuration);

  const countdownInterval = setInterval(() => {
    if (!timeDifference) {
      clearInterval(countdownInterval);
      return;
    }
    timeDifference -= 1000;
    const newDuration = dayjs.duration(timeDifference);
    updateCounters(newDuration);
  }, 1000);

  return () => {
    clearInterval(countdownInterval);
  };
});
